import React from 'react';
import { HelpCircle, Pencil } from 'lucide-react';
import { Card } from './Card';
import ActionButton from './ActionButton';

// Multi-select answers (questionType 3 / 4) arrive either as an array or as a comma-joined string
// with a trailing comma. Parsed the same way the old layout did.
const choiceAnswers = answer => {
    if (Array.isArray(answer)) return answer.filter(a => a !== null && a !== undefined).map(String);
    if (typeof answer === 'string') return answer.replace(/,\s*$/, '').split(',');
    return [];
};

const isChoice = question => question.questionType === 3 || question.questionType === 4;

const Answer = ({ children }) => (
    children === null || children === undefined || String(children).trim() === ''
        ? <span className="tw-text-sm tw-italic tw-text-neutral-400">Not answered</span>
        : <span className="tw-whitespace-pre-line tw-break-words tw-text-sm tw-text-neutral-800">{children}</span>
);

const QuestionRow = ({ number, title, children }) => (
    <li className="tw-flex tw-flex-col tw-gap-1 tw-border-t tw-border-neutral-100 tw-py-2.5 first:tw-border-t-0 first:tw-pt-0 last:tw-pb-0">
        <span className="tw-text-sm tw-font-medium tw-text-neutral-600">
            {number ? <span className="tw-mr-1 tw-text-neutral-400">{number}.</span> : null}
            {title}
        </span>
        {children}
    </li>
);

/**
 * Registration questions for this participant (`camperQuestions`, editable through the existing
 * answers modal via `onEdit`) followed by the booking's other questions (`bookingQuestions`,
 * read-only, as before).
 */
const QuestionsCard = ({ camperQuestions = [], bookingQuestions = [], onEdit }) => {
    const empty = !camperQuestions.length && !bookingQuestions.length;

    return (
        <Card
            id="questions"
            title="Questions"
            icon={HelpCircle}
            actions={camperQuestions.length ? <ActionButton variant="primary" icon={Pencil} onClick={onEdit}>Edit answers</ActionButton> : null}
        >
            {empty
                ? <p className="tw-text-sm tw-italic tw-text-neutral-400">No additional questions for this booking.</p>
                : <ul>
                    {camperQuestions.map((q, i) => (
                        <QuestionRow key={q._id || `c${i}`} number={i + 1} title={q.title}>
                            {isChoice(q)
                                ? (choiceAnswers(q.answer).filter(a => a.trim()).length
                                    ? <div className="tw-flex tw-flex-wrap tw-gap-1.5">
                                        {choiceAnswers(q.answer).filter(a => a.trim()).map((a, j) => (
                                            <span key={j} className="tw-rounded tw-bg-neutral-100 tw-px-2 tw-py-0.5 tw-text-sm tw-text-neutral-700">{a.trim()}</span>
                                        ))}
                                    </div>
                                    : <Answer />)
                                : <Answer>{q.answer}</Answer>}
                        </QuestionRow>
                    ))}
                    {bookingQuestions.map((q, i) => (
                        <QuestionRow key={q._id || `b${i}`} title={q.question}>
                            <Answer>{q.answer}</Answer>
                        </QuestionRow>
                    ))}
                </ul>}
        </Card>
    );
};

export default QuestionsCard;
